import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";

import { HeroIcons } from "./types";

import UiIconBtn from "./UiIconBtn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiModalPageHeaderButton',
  props: {
  icon: { type: String as PropType<HeroIcons>, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiIconBtn, {
    icon: __props.icon,
    variant: "tertiary",
    size: "md"
  }, null, 8, ["icon"]))
}
}

})